export type CardGraphics = {
  icon?: string;
  iconbg?: string;
  iconshadow?: string;
  bordercolor?: string;
  imgurl?: string;
};

export type PillarWithGraphics = {
  id?: string | number;
  prefix?: string;
  pillar_prefix?: string;
  competency_prefix?: string;
  title?: string;
  graphics?: CardGraphics;
};

export function getCompetencyPillarPrefix(competencyCode: string): string {
  return competencyCode?.split("-")[0] ?? "";
}

export function findPillarForCompetency(
  pillars: PillarWithGraphics[],
  competencyCode: string,
  templatePillarId?: string | number
): PillarWithGraphics | undefined {
  if (!pillars?.length) {
    return undefined;
  }

  if (templatePillarId !== undefined && templatePillarId !== null && templatePillarId !== "") {
    const byId = pillars.find(
      (pillar) => String(pillar.id) === String(templatePillarId)
    );
    if (byId) {
      return byId;
    }
  }

  const prefix = getCompetencyPillarPrefix(competencyCode);
  if (!prefix) {
    return undefined;
  }

  return pillars.find(
    (pillar) =>
      pillar.prefix === prefix ||
      pillar.pillar_prefix === prefix ||
      pillar.competency_prefix === prefix
  );
}

export function mergeCardGraphics(
  cardGraphics?: CardGraphics | null,
  pillarGraphics?: CardGraphics | null
): CardGraphics {
  const merged: CardGraphics = { ...(cardGraphics ?? {}) };

  if (!pillarGraphics) {
    return merged;
  }

  if (pillarGraphics.icon) {
    merged.icon = pillarGraphics.icon;
  }
  if (pillarGraphics.iconbg) {
    merged.iconbg = pillarGraphics.iconbg;
  }
  if (pillarGraphics.iconshadow) {
    merged.iconshadow = pillarGraphics.iconshadow;
  }
  if (pillarGraphics.bordercolor) {
    merged.bordercolor = pillarGraphics.bordercolor;
  }

  return merged;
}

export function getCardGraphics(
  card: {
    competency_code: string;
    graphics?: CardGraphics;
    template_pillar_id?: string | number;
  },
  pillars: PillarWithGraphics[]
): CardGraphics {
  const pillar = findPillarForCompetency(
    pillars,
    card.competency_code,
    card.template_pillar_id
  );

  return mergeCardGraphics(card.graphics, pillar?.graphics);
}
